import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const usersStyle = (theme) => ({
	addUserCard: {
		height: '398px',
		position: 'relative',
		[theme.breakpoints.up('lg')]: {
			height: 'calc(100% - 32px)',
		},
		[theme.breakpoints.down('xs')]: {
			height: 'auto',
		},
		'& > div': {
			// card body
			padding: '32px',
		},
	},
	addUserCardWithButton: {
		'& > div': {
			// card body
			paddingBottom: '92px',
		},
	},
	addUserInfoCard: {
		marginTop: 0,
		[theme.breakpoints.down('lg')]: {
			height: 'auto',
		},
		'& > div': {
			// card body
			paddingTop: '10px',
		},
	},
	addUserButtonWrapper: {
		width: '100%',
		textAlign: 'right',
		position: 'absolute',
		bottom: '32px',
		left: 0,
		paddingLeft: '32px',
		paddingRight: '32px',
		'& button': {
			margin: 0,
		},
	},
	divider: {
		width: '100%',
		height: '2px',
		backgroundColor: '#979797',
		margin: '0 12px',
		marginBottom: '16px',
	},
	infoWrapper: {
		'& > div': {
			'&:first-of-type': {
				marginBottom: '8px',
			},
		},
	},
	iconWrapper: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginBottom: '8px',
		'& svg': {
			width: '100%',
			height: 'auto',
			maxWidth: '80px',
		},
	},
	listWrapper: {
		'& > div': {
			display: 'flex',
			alignItems: 'center',
			marginBottom: '16px',
			'&:last-of-type': {
				marginBottom: 0,
			},
			'& svg': {
				width: '16px',
				height: '16px',
				marginRight: '8px',
				position: 'relative',
				bottom: '1px',
			},
		},
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	inlineIcon: {
		height: 16,
		width: 16,
		objectFit: 'cover',
		marginRight: 8,
	},
	accountPickerWrapper: {
		'& > div': {
			maxWidth: '219px',
			[theme.breakpoints.down('sm')]: {
				maxWidth: 'unset',
			},
		},
	},
	csvUploadTexts: {
		[theme.breakpoints.up('sm')]: {
			maxWidth: '369px',
		},
		[theme.breakpoints.down('xs')]: {
			marginBottom: '20px',
		},
	},
	fileUploadWrapper: {
		maxWidth: '325px',
		marginRight: 0,
		marginLeft: 'auto',
		[theme.breakpoints.down('xs')]: {
			margin: '0 auto',
		},
	},
	csvImportWrapper: {
		padding: '32px 42px',
	},
	downloadLink: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
	},
	leftAligned: {
		justifyContent: 'flex-start',
	},
	warning: {
		marginTop: '20px',
	},
	userInfoDialogWrapper: {
		padding: '0 12px',
	},
	tableWrapper: {
		'& .ReactTable .rt-td': {
			overflow: 'inherit',
		},
	},
	buttonsWrapper: {
		'& button': {
			margin: 0,
		},
	},
	alternativeSelectUserType: {
		minWidth: '120px',
	},
	alternativeSelectDepartment: {
		minWidth: '160px',
	},
});

export default usersStyle;
